<template>
  <div class="c-input-text">
    <label
      :for="name"
      class="c-input-text__label c-input-label"
    >{{ label }}</label>
    <input
      :id="name"
      ref="field"
      :value="formattedValue"
      :placeholder="placeholder"
      :name="name"
      :class="{ 'errors c-input-field--error': hasError }"
      class="c-input-text__field c-input-field"
      type="text"
      maxlen="10"
      v-bind="$attrs"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @input="handleInput($event.target.value)"
    >
    <p
      :id="`${name}-error`"
      class="c-input-text__helper c-input-helper"
    >
      <slot name="helper" />
    </p>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InputCFPSID',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Label',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedValue() {
      return this.formatValue(this.value);
    },
  },
  methods: {
    formatValue(value) {
      return value
        .split('')
        .reduce((cfpsid, char, indx) => {
          switch (indx) {
            case 4:
            case 8:
            case 12:
              return `${cfpsid}-${char}`;

            default:
              return `${cfpsid}${char}`;
          }
        }, '');
    },
    handleInput(event) {
      const value = event
        .replace(/\D/g, '')
        .substring(0, 16);

      this.$emit('input', value);
      this.$refs.field.value = this.formatValue(value);
    },
  },
};
</script>

<style>
.c-input-field {
  color: #000 !important;
}
</style>